import { useUserTimeZone } from "@/hooks/useUserTimeZone";

function abbreviation(timeZone: string): string {
  const part = new Intl.DateTimeFormat("en-US", {
    timeZone,
    timeZoneName: "short",
  })
    .formatToParts(new Date())
    .find(({ type }) => type === "timeZoneName");
  return part?.value ?? "UTC";
}

/** Quiet, read-only indication of the browser timezone used by the app. */
export function TimeZoneDisplay() {
  const timeZone = useUserTimeZone();
  const shortName = abbreviation(timeZone);

  return (
    <span
      className="time-zone-display"
      data-testid="time-zone-display"
      title={`Times shown in ${timeZone}`}
      aria-label={`Local timezone: ${timeZone}`}
    >
      {shortName}
    </span>
  );
}
